<div class="patient-detail-container">
  <app-patient-overview [patient]="patient"></app-patient-overview>
  <div class="content-panel">
    <ng-template #chatTemplate>
      <div class="tab-content chat-pane">
        <div class="pane-header">
          <span class="view-label">{{
            "workListDetail.chat" | translate
          }}</span>
        </div>
        <app-chat
          [groupId]="patientId"
          [assignedDoctorIds]="assignedDoctorIds"
          [patientInfo]="patient"
        ></app-chat>
      </div>
    </ng-template>

    <ng-template #aiAssistantTemplate>
      <div class="tab-content ai-assistant-pane">
        <app-ai-assistant
          [patient]="patient"
          [wound]="wound"
          [woundMetrics]="parsedMetrics"
        ></app-ai-assistant>
      </div>
    </ng-template>

    <ng-template #conclusionTemplate>
      <div class="tab-content conclusion-tab">
        <app-conclusion
          [patientId]="patientId"
          [woundId]="woundId"
          [isConclusionExist]="isConclusionExit"
        ></app-conclusion>
      </div>
    </ng-template>

    <ng-template #metricsTemplate>
      <div class="tab-content metrics-tab">
        <app-wound-analysis-metrics
          [woundId]="woundId"
          [wound]="wound"
        ></app-wound-analysis-metrics>
      </div>
    </ng-template>

    <ng-template #documentsTemplate>
      <div class="tab-content documents-tab">
        <div class="pane-header">
          <span class="view-label">{{
            "workListDetail.tests" | translate
          }}</span>
        </div>
        <div class="documents-container">
          <app-document-manager
            [patientId]="patientId"
            [woundId]="woundId"
            [readOnlyDocumentUpload]="!canUploadDocuments"
          ></app-document-manager>
        </div>
      </div>
    </ng-template>

    <ng-template #patientTemplate>
      <div class="tab-content patient-content">
        <div class="grid-selector">
          <button
            [class.active]="grid === 1"
            (click)="setGrid(1)"
            type="button"
          >
            {{ "workListDetail.oneView" | translate }}
          </button>
          <button
            [class.active]="grid === 2"
            (click)="setGrid(2)"
            type="button"
          >
            {{ "workListDetail.twoView" | translate }}
          </button>
        </div>

        <div
          class="image-grid"
          [class.grid-1]="grid === 1"
          [class.grid-2]="grid === 2"
        >
          <div
            class="image-card"
            *ngFor="let img of visibleImages; trackBy: trackByDicomUrl"
          >
            <app-dicom-viewer [src]="img.dicomUrl"></app-dicom-viewer>
            <span class="image-date">{{ img.date }}</span>
          </div>
        </div>
      </div>
    </ng-template>

    <ng-container
      *ngIf="
        showModelViewer && woundIds && woundIds.length > 0;
        else noWoundsLayout
      "
    >
      <app-model-viewer-page
        [woundIds]="woundIds"
        [woundDateMap]="woundDateMap"
        [showScalesControl]="true"
        [activeTab]="activeTab"
        [wound]="wound"
      >
        <div class="projected-content h-100">
          <ng-container *ngIf="activeTab === 'chat'">
            <ng-container *ngTemplateOutlet="chatTemplate"></ng-container>
          </ng-container>
          <ng-container *ngIf="activeTab === 'conclusion'">
            <ng-container *ngTemplateOutlet="conclusionTemplate"></ng-container>
          </ng-container>
          <ng-container *ngIf="activeTab === 'tahliller'">
            <ng-container *ngTemplateOutlet="documentsTemplate"></ng-container>
          </ng-container>
          <ng-container *ngIf="activeTab === 'patient'">
            <ng-container *ngTemplateOutlet="patientTemplate"></ng-container>
          </ng-container>
          <ng-container *ngIf="activeTab === 'metrics'">
            <ng-container *ngTemplateOutlet="metricsTemplate"></ng-container>
          </ng-container>
          <ng-container *ngIf="activeTab === 'ai-assistant'">
            <ng-container *ngTemplateOutlet="aiAssistantTemplate"></ng-container>
          </ng-container>
        </div>
      </app-model-viewer-page>
    </ng-container>

    <ng-template #noWoundsLayout>
      <div class="h-100">
        <ng-container *ngIf="activeTab === 'chat'">
          <ng-container *ngTemplateOutlet="chatTemplate"></ng-container>
        </ng-container>
        <ng-container *ngIf="activeTab === 'conclusion'">
          <ng-container *ngTemplateOutlet="conclusionTemplate"></ng-container>
        </ng-container>
        <ng-container *ngIf="activeTab === 'tahliller'">
          <ng-container *ngTemplateOutlet="documentsTemplate"></ng-container>
        </ng-container>
        <ng-container *ngIf="activeTab === 'patient'">
          <ng-container *ngTemplateOutlet="patientTemplate"></ng-container>
        </ng-container>
        <ng-container *ngIf="activeTab === 'metrics'">
          <ng-container *ngTemplateOutlet="metricsTemplate"></ng-container>
        </ng-container>
        <ng-container *ngIf="activeTab === 'ai-assistant'">
          <ng-container *ngTemplateOutlet="aiAssistantTemplate"></ng-container>
        </ng-container>
      </div>
    </ng-template>

    <div class="floating-nav">
      <button
        class="nav-btn"
        [class.active]="activeTab === 'models'"
        (click)="activeTab = 'models'"
      >
        <svg
          class="icon"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
        >
          <path
            d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"
          ></path>
          <polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline>
          <line x1="12" y1="22.08" x2="12" y2="12"></line>
        </svg>
        <span class="nav-label">{{ "workListDetail.models" | translate }}</span>
      </button>

      <button
        class="nav-btn"
        [class.active]="activeTab === 'tahliller'"
        (click)="activeTab = 'tahliller'"
      >
        <svg
          class="icon"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
        >
          <path d="M9 2v4"></path>
          <path d="M15 2v4"></path>
          <rect x="3" y="4" width="18" height="18" rx="2"></rect>
          <path d="M3 10h18"></path>
          <path d="M8 14h.01"></path>
          <path d="M12 14h.01"></path>
          <path d="M16 14h.01"></path>
          <path d="M8 18h.01"></path>
          <path d="M12 18h.01"></path>
        </svg>
        <span class="nav-label">{{ "workListDetail.tests" | translate }}</span>
      </button>

      <button
        class="nav-btn"
        [class.active]="activeTab === 'chat'"
        (click)="activeTab = 'chat'"
      >
        <svg
          class="icon"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
        >
          <path
            d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"
          ></path>
        </svg>
        <span class="nav-label">{{ "workListDetail.chat" | translate }}</span>
      </button>

      <button
        class="nav-btn"
        [class.active]="activeTab === 'conclusion'"
        (click)="activeTab = 'conclusion'"
        [disabled]="shouldDisableConclusionButton"
        [class.btn-disabled]="shouldDisableConclusionButton"
      >
        <svg
          class="icon"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
        >
          <path d="M9 12l2 2 4-4"></path>
          <path
            d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
          ></path>
          <path d="M14 2v6h6"></path>
        </svg>

        <span class="nav-label">{{ "conclusion" | translate }}</span>
      </button>

      <button
        class="nav-btn"
        [class.active]="activeTab === 'metrics'"
        (click)="activeTab = 'metrics'"
      >
        <svg
          class="icon"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
        >
          <circle cx="11" cy="11" r="8"></circle>
          <path d="M21 21l-4.35-4.35"></path>
          <path d="M11 8v6"></path>
          <path d="M8 11h6"></path>
        </svg>
        <span class="nav-label">{{ "modelViewer.metrics" | translate }}</span>
        <span class="nav-badge" *ngIf="wound?.isProcessing"></span>
      </button>

      <button
        class="nav-btn"
        [class.active]="activeTab === 'ai-assistant'"
        (click)="activeTab = 'ai-assistant'"
      >
        <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <rect x="2" y="8" width="20" height="12" rx="3"></rect>
          <path d="M8 8V6a4 4 0 0 1 8 0v2"></path>
          <circle cx="8.5" cy="14" r="1.5" fill="currentColor" stroke="none"></circle>
          <circle cx="15.5" cy="14" r="1.5" fill="currentColor" stroke="none"></circle>
          <path d="M10 17.5h4" stroke-linecap="round"></path>
          <path d="M12 2v2" stroke-linecap="round"></path>
        </svg>
        <span class="nav-label">AI Asistan</span>
      </button>

      <!-- <button
        class="nav-btn"
        [class.active]="activeTab === 'patient'"
        (click)="activeTab = 'patient'"
      >
        <svg
          class="icon"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
        >
          <rect x="3" y="3" width="18" height="18" rx="2"></rect>
          <circle cx="8.5" cy="8.5" r="1.5"></circle>
          <path d="M21 15l-5-5L5 21"></path>
        </svg>
        <span class="nav-label">{{
          "workListDetail.patientDetail" | translate
        }}</span>
      </button> -->
    </div>

    <!-- Wound Timeline -->
    <app-wound-timeline
      [wounds]="wounds"
      [patientId]="patientId"
      (allWoundIdsCalculated)="onWoundIdsCalculated($event)"
      [navigateOnClick]="false"
      (woundClicked)="onTimelineWoundClick($event)"
    ></app-wound-timeline>
  </div>
</div>
